import { Chart } from 'chart.js';
import { CalendarComponentOptions } from 'ion2-calendar';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component,ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';



@Component({
  selector: 'page-marka-bazli-rapor',
  templateUrl: 'marka-bazli-rapor.html',
})
export class MarkaBazliRaporPage {
  @ViewChild('sideNavUrunAra') sideNav;
  @ViewChild('chartCanvas') chartCanvas;
  gelenRapor = [];
  tarih1: any;
  tarih2: any;
  chartVar: any;
  satistoplami:number=0;
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "danger",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };

  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public navParams: NavParams) {
    this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
    this.tarih2 = this.tarih1;
  }

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.RaporuGetir();
    this.closeNav();
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }
  RaporuGetir() {
    var formData = new FormData();
    formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
    formData.append("tarih2", this.ortak.tarih(this.dateRange.to));
    this.bllOrtak.islem(formData, "MarkaBazliRapor", "", true).then(a => {
      var sonuc = <any>a;
  
      this.gelenRapor = sonuc.SonucObject;
      this.gelenRapor.forEach(element=>{
        this.satistoplami+=element.Tutar;
      })
      this.closeNav();
  
   
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/Raporlars/marka-bazli-rapor/marka-bazli-rapor.ts